export default __webpack_public_path__ + "static/media/css.82149eef.svg";